var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("Extrato")]),_c('p',[_vm._v("Nossa nova tela de extrato. Depende da api para criarmos a tela.")])])
}]

export { render, staticRenderFns }